import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import _ from "lodash";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchOnlyQuizzes,
  deleteOnlyQuiz,
} from "../../../store/reducers/onlyQuizSectionSlice";

const OnlyQuizSection = () => {
  const itemsPerPage = 10;
  const history = useHistory();
  const dispatch = useDispatch();

  const { onlyQuizzes, total, loading } = useSelector((state) => state.onlyQuiz);

  const [currentPage, setCurrentPage] = useState(1);
  const [onlyQuizFilter, setOnlyQuizFilter] = useState("");
  const [debouncedOnlyQuiz, setDebouncedOnlyQuiz] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedOnlyQuizId, setSelectedOnlyQuizId] = useState(null);

  /* ================= FETCH DATA ================= */

  const pageCount = Math.ceil(total / itemsPerPage);
  const loadOnlyQuizzes = (pageNo = 1, search = "") => {
    dispatch(
      fetchOnlyQuizzes({
        page: pageNo,
        limit: itemsPerPage,
        search: search,
        key:"all"
      })
    );
  };

  useEffect(() => {
    loadOnlyQuizzes(currentPage, debouncedOnlyQuiz);
  }, [currentPage, debouncedOnlyQuiz]);

  useEffect(() => {
    const handler = _.debounce((value) => {
      setDebouncedOnlyQuiz(value);
      setCurrentPage(1);
    }, 500);

    handler(onlyQuizFilter);

    return () => handler.cancel();
  }, [onlyQuizFilter]);


  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };

  const handleOnlyQuizFilterChange = (e) => {
    setOnlyQuizFilter(e.target.value);
  };

  const handelAddOnlyQuiz = () => {
    history.push("/admin-manage-quiz");
  };

  const handleDeleteClick = (id) => {
    setSelectedOnlyQuizId(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await dispatch(deleteOnlyQuiz(selectedOnlyQuizId)).unwrap();

      toast.success("OnlyQuiz deleted successfully");

      setShowDeleteModal(false);
    } catch (error) {
      toast.error("Delete failed");
    }
  };

  return (
    <>
      <div className="row my-2 align-items-center">
        <div className="col-12 d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="fw-bold mb-2 mb-md-0" style={{ minWidth: 120 }}>
            OnlyQuiz Section
          </div>
          <div
            className="d-flex justify-content-center align-items-center gap-2 mx-auto"
            style={{ maxWidth: 600, width: "100%" }}
          >
            <input
              type="text"
              className="form-control"
              style={{ minWidth: 300 }}
              placeholder="Search by onlyQuiz"
              value={onlyQuizFilter}
              onChange={handleOnlyQuizFilterChange}
            />

            {onlyQuizFilter && (
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => setOnlyQuizFilter("")}
              >
                Clear
              </button>
            )}
          </div>

          <button
            className="btn bg_color"
            type="button"
            onClick={handelAddOnlyQuiz}
          >
            Add New Quiz
          </button>
        </div>
      </div>

      <table className="table align-middle">
        <thead>
          <tr>
            <th>Sr. No</th>
            <th>Quiz Title</th>
            <th>Quiz Title DK</th>
            <th style={{ width: "70px", textAlign: "center" }}>Edit</th>
            <th style={{ width: "80px", textAlign: "center" }}>Remove</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="6" className="text-center">
                Loading...
              </td>
            </tr>
          ) : (
            onlyQuizzes?.map((item, i) => (
              <tr key={item.id}>
                <td>{i + 1 + itemsPerPage * (currentPage - 1)}</td>


                <td>{item.name}</td>
                <td>{item.name_dk}</td>

                {/* EDIT */}

                <td className="text-center">
                  <button
                    className="btn btn-sm bg_color"
                    onClick={() =>
                      history.push({
                        pathname: "/admin-manage-quiz",
                        search: `?id=${item.id}`,
                      })
                    }
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                </td>

                {/* DELETE */}

                <td className="text-center">
                  <button
                    className="btn btn-sm bg_color"
                    onClick={() => handleDeleteClick(item.id)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))
          )}

          <tr hidden={onlyQuizzes?.length !== 0 || loading}>
            <td colSpan="6" className="text-center">
              Data Not Found
            </td>
          </tr>
        </tbody>
      </table>

      {/* PAGINATION */}

      <ReactPaginate
        nextLabel="Next"
        previousLabel="Previous"
        onPageChange={handlePageClick}
        pageCount={pageCount}
        forcePage={currentPage - 1}
        pageRangeDisplayed={5}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
      />
      {/* DELETE MODAL */}

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this Quiz?</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            No
          </Button>

          <Button variant="danger" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OnlyQuizSection;
